<template>
  <div class="content">
    <p>商家升级</p>
    <el-table :data="UpgradeList">
      <el-table-column prop="userId" label="用户ID" width="180"> </el-table-column>
      <el-table-column prop="merchantId" label="merchantId"> </el-table-column>
      <el-table-column prop="levelName" label="等级"> </el-table-column>
      <el-table-column prop="" label="冻结币种数">
        <template slot-scope="scope">
          <span>{{ scope.row.freezeAmount }}{{ scope.row.freezeCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <span> {{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">升级中</span>
          <span v-if="scope.row.status == 1">通过</span>
          <span v-if="scope.row.status == 2">不通过</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="auditHandleClick(scope.row)" type="text" v-if="scope.row.status==0" size="small">审核</el-button>
          <el-button @click="auditHandleClick(scope.row)" type="text" v-else disabled size="small">审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="审核" :visible.sync="auditlVisible" width="40%" center>
      审核ID:{{ auditForm.id }}
      <el-form :model="auditForm" status-icon ref="auditForm" label-width="100px" class="applicationForm">
        <div class="fenGeXian"></div>
        <p class="fromCaptionTitle">审核理由</p>
        <el-form-item label="理由" prop="nickName">
          <el-input type="textarea" v-model="auditForm.reason"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">审核状态</p>

        <el-form-item label="状态">
          <el-select v-model="auditForm.status" placeholder="请选择审核状态">
            <!-- <el-option label="升级中" value="0"></el-option> -->
            <el-option label="通过" value="1"></el-option>
            <el-option label="不通过" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditlVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      // MerchantRecordList:{}
      merchantDetailVisible: false,
      auditlVisible: false,
      ruleForm: {},
      auditForm: {
        id: "", //审核
        reason: "",
        status: ""
      }
    };
  },
  computed: {
    ...mapState("otc", ["UpgradeList"])
  },
  components: {},
  methods: {
    ...mapActions("otc", ["getUpgradeList"]),

    //审核

    auditHandleClick(row) {
      let that = this;
      this.auditlVisible = true;
      this.auditForm.id = row.id;
    },

    auditBtn() {
      let that = this;
      let data = this.auditForm;
      api.auditUpgrade(data).then(res => {
        console.log("审核", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.auditlVisible=false;
          that.getUpgradeList();

        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },

  mounted() {
    this.getUpgradeList();
  }
};
</script>

<style lang="less" scoped>
.content {
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
</style>
